import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { GET_USER, DELETE_USER, EDIT_USER, ADD_USER, UPDATE_USER_STATUS, GET_THEME, IMPORT_USER_DATA, GET_USER_SERVICES, DOWNLOAD_CSV_USERS } from "../Constants";
import { defaultHeaders } from "../Constants/DefaultHeaders";
import { logout } from "../../utils";
import { GetUserSuccess, GetUserFailure, DeleteUserSuccess, DeleteUserFailure, EditUserSuccess, EditUserFailure, AddUserSuccess, AddUserFailure, UpdateUserStatusSuccess, UpdateUserStatusFailure, GetThemeSuccess, GetThemeFailure, GetUserServicesSuccess, GetUserServicesFailure, ImportDataDataSuccess, ImportDataDataFailure, GetUserCsvFailure, GetUserCsvSuccess } from "../Actions/UserAction";

function* GetUserRequest(actions) {
  try {
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/users?status=${actions.payload.status}&page=${actions.payload.page}&sort_by=${actions.payload.sort_by}&sort_type=${actions.payload.sort_type}&search_key=${actions.payload.search_key}&user_type=${actions.payload.users}`, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(GetUserSuccess(res.data));
    } else {
      yield put(GetUserFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetUserFailure(e));
  }
}

function* DeleteUserRequest(actions) {
  try {
    const res = yield axios.delete(`${process.env.REACT_APP_API_URL}api/admin/user/${actions.payload}`, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(DeleteUserSuccess(res.data));
    } else {
      yield put(DeleteUserFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(DeleteUserFailure(e));
  }
}

function* EditUserRequest(actions) {
  const body = {
    id: actions.payload.id,
    full_name: actions.payload.full_name,
    first_name: actions.payload.first_name,
    last_name: actions.payload.last_name,
    primary_account: actions.payload.primary_account,
    email: actions.payload.email,
    theme_id: actions.payload.theme_id,
    user_type: actions.payload.user_type,
    balance: actions.payload.balance,
    user_services: actions.payload.user_services,
    sec_level: actions.payload.sec_level,
    business_admin: actions.payload.business_admin,
    test_user: actions.payload.test_user,
  };

  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/edit_user`, body, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(EditUserSuccess(res.data));
    } else {
      yield put(EditUserFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(EditUserFailure(e));
  }
}

function* AddUserRequest(actions) {
  const body = {
    id: actions.payload.id,
    full_name: actions.payload.full_name,
    first_name: actions.payload.first_name,
    last_name: actions.payload.last_name,
    primary_account: actions.payload.primary_account,
    email: actions.payload.email,
    theme_id: actions.payload.theme_id,
    role_id: actions.payload.user_type,
    balance: actions.payload.balance,
    user_services: actions.payload.user_services,
    sec_level: actions.payload.sec_level,
    business_admin: actions.payload.business_admin,
    test_user: actions.payload.test_user,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/add_user`, body, { headers: defaultHeaders() });
    if (res.status === 200) {
      //yield alert(JSON.stringify(body));
      yield put(AddUserSuccess(res.data));
    } else {
      yield put(AddUserFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(AddUserFailure(e));
  }
}

function* UpdateUserStatusRequest(actions) {
  const body = {
    id: actions.payload.id,
    user_status: actions.payload.user_status,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/change_status`, body, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(UpdateUserStatusSuccess(res.data));
    } else {
      yield put(UpdateUserStatusFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateUserStatusFailure(e));
  }
}

function* GetThemeRequest() {
  try {
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/theme_dropdown_list`, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(GetThemeSuccess(res.data));
    } else {
      yield put(GetThemeFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetUserFailure(e));
  }
}

function* ImportDataRequest(actions) {
  let data = [];
  actions &&
    actions.payload &&
    actions.payload.map((arr) => {
      data.push(arr);
    });
  const body = {
    data,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/import_users_data`, body, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(ImportDataDataSuccess(res.data));
    } else {
      yield put(ImportDataDataFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(ImportDataDataFailure(e));
  }
}

function* GetUserServiceList() {
  try {
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/services/0?status=1&user_type=2,3`, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(GetUserServicesSuccess(res.data.data));
    } else {
      yield put(GetUserServicesFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetUserFailure(e));
  }
}

function* GetCsvUsers() {
  try {
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/export_user_template`, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(GetUserCsvSuccess(res.data.data));
    } else {
      yield put(GetUserCsvFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetUserCsvFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(GET_USER, GetUserRequest);
  yield takeLatest(GET_THEME, GetThemeRequest);
  yield takeLatest(DELETE_USER, DeleteUserRequest);
  yield takeLatest(EDIT_USER, EditUserRequest);
  yield takeLatest(ADD_USER, AddUserRequest);
  yield takeLatest(UPDATE_USER_STATUS, UpdateUserStatusRequest);
  yield takeLatest(IMPORT_USER_DATA, ImportDataRequest);
  yield takeLatest(GET_USER_SERVICES, GetUserServiceList);
  yield takeLatest(DOWNLOAD_CSV_USERS, GetCsvUsers);
}

export default function* GetUserSaga() {
  yield all([actionWatcher()]);
}
